
















































































































import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import STextarea from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import FileUploadUiComponent from '@/tasks/components/task-ui-components/FileUploadUiComponent.vue';
import STextareaShort from '@/common/components/STextareaShort.vue';

export default {
  name: 'McMaster_Chem2OA3_Lab2_ReportSheet',
  components: {FileUploadUiComponent, TableInput, STextarea, CalculationInput, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        unknownNumber: null,
        compounds: [],
        unknownIdentity: null,
        discussion: null,
        conclusion: null,
        rows1: [
          {
            spotLabel: '',
            dToSpot: '',
            dToFront: '',
            rf: '',
          },
        ],
        rows2: [
          {
            spotLabel: '',
            dToSpot: '',
            dToFront: '',
            rf: '',
          },
        ],
      },
      columns: [
        {
          label: 'Spot Label',
          component: STextareaShort,
          prop: 'spotLabel',
          width: '25%',
        },
        {
          label: 'Spot distance (cm)',
          component: CalculationInput,
          prop: 'dToSpot',
          width: '25%',
        },
        {
          label: 'Solvent front distance (cm)',
          component: CalculationInput,
          prop: 'dToFront',
          width: '25%',
        },
        {label: 'Rf value', component: CalculationInput, prop: 'rf', width: '25%'},
      ],
      compoundOptions: [
        {text: 'Acetaminophen', value: 'acetaminophen'},
        {text: 'Aspirin', value: 'aspirin'},
        {text: 'Ibuprofen', value: 'ibuprofen'},
        {text: 'Diphenhydramine', value: 'diphenhydramine'},
        {text: 'Caffeine', value: 'caffeine'},
        {text: 'Ephedrine', value: 'ephedrine'},
      ],
      analgesicOptions: [
        {
          text: 'Advil Tablets/Caplets',
          value: 'Advil Tablets/Caplets',
        },
        {
          text: 'Advil Nighttime',
          value: 'Advil Nighttime',
        },
        {
          text: 'Advil Cold and Sinus Daytime',
          value: 'Advil Cold and Sinus Daytime',
        },
        {
          text: 'Advil Dual Action',
          value: 'Advil Dual Action',
        },
        {
          text: 'Anacin Tablets',
          value: 'Anacin Tablets',
        },
        {
          text: 'Aspirin Original Strength',
          value: 'Aspirin Original Strength',
        },
        {
          text: 'Benylin All-in-One',
          value: 'Benylin All-in-One',
        },
        {
          text: 'Excedrin Back and Body',
          value: 'Excedrin Back and Body',
        },
        {
          text: 'Excedrin Extra Strength',
          value: 'Excedrin Extra Strength',
        },
        {
          text: 'Excedrin PM Headache',
          value: 'Excedrin PM Headache',
        },
        {
          text: 'Tylenol Regular Strength',
          value: 'Tylenol Regular Strength',
        },
        {
          text: 'Tylenol Ultra-Relief',
          value: 'Tylenol Ultra-Relief',
        },
        {
          text: 'Tylenol Nighttime',
          value: 'Tylenol Nighttime',
        },
        {
          text: 'Tylenol Cold and Sinus Daytime',
          value: 'Tylenol Cold and Sinus Daytime',
        },
      ],
      attachments: [] as File[],
    };
  },
};
